import { type ProductName_Top } from 'gw-edge-client/dist/types/dto/pc/typekey';
import type { HighlightNoteContent } from '../types';
import {
    AREA_DESTINATION_ONLY_EUROPE,
    AREA_DESTINATION_WORLDWIDE,
    PRC_EXTENDED_ELECTRONIC_COV,
    PRC_GLASS_SANITATION_COV,
    TRA_CANCELLATION_COV,
    TRA_SKIING_COV,
    TRA_TOP_CANCELLATION_COV,
    TRAVEL_TYPE_HOUSEHOLD
} from '../../../constants/coverage';

type coverageId = string;

interface IAddCoverageConfig {
    coverageTitleAppend: {
        [key in ProductName_Top]?: Record<coverageId, string>;
    };
    shouldHideCoverageSubtitle: {
        [key in ProductName_Top]?: boolean;
    };
    shouldMoveInfoBoxToBottom: {
        [key in ProductName_Top]?: Record<coverageId, boolean>;
    };
    shouldCoverageShowEffectiveDate: Record<coverageId, boolean>;
}

const AddCoverageConfig: IAddCoverageConfig = {
    coverageTitleAppend: {
        top_prc_youth_content: {
            [PRC_EXTENDED_ELECTRONIC_COV]: '& kortslutning'
        }
    },
    shouldHideCoverageSubtitle: {
        top_tra_household: true,
        top_tra_individual: true
    },
    shouldMoveInfoBoxToBottom: {
        top_tra_household: {
            [TRA_CANCELLATION_COV]: true
        },
        top_tra_individual: {
            [TRA_CANCELLATION_COV]: true
        }
    },
    shouldCoverageShowEffectiveDate: {
        [TRA_CANCELLATION_COV]: true,
        [TRA_SKIING_COV]: true
    }
};

const getAddCoverageHighlightNote = (
    coverageId: string,
    coverageSubtitle: string,
    flavourName: string,
    renewalDate: string = '',
    getHippoText: (
        resourceKey: string,
        replaceTexts?: Record<string, string | number>
    ) => string = () => ''
): HighlightNoteContent | undefined => {
    switch (coverageId) {
        case PRC_GLASS_SANITATION_COV:
            return {
                noteTitle: 'Vær opmærksom på:',
                noteText: getHippoText(
                    'DSS-ADD-SIMPLE-COVERAGE-CANCELLATION-COVERAGE-INFORMATION-GLASS-SANITATION'
                ),
                noteDescription: coverageSubtitle,
                theme: 'warning'
            };
        case PRC_EXTENDED_ELECTRONIC_COV:
            if (flavourName === 'top_prc_content') return undefined;
            return {
                noteText: getHippoText(
                    'DSS-ADD-SIMPLE-COVERAGE-CANCELLATION-COVERAGE-INFORMATION-PRCExtendedElectronicCov'
                ),
                noteDescription: getHippoText(
                    'DSS-ADD-SIMPLE-COVERAGE-CANCELLATION-COVERAGE-INFORMATION-PRCExtendedElectronicCov-subtitle',
                    { coverageSubtitle }
                ),
                theme: 'warning'
            };
        case TRA_TOP_CANCELLATION_COV:
            return {
                noteTitle: getHippoText(
                    'DSS-ADD-SIMPLE-COVERAGE-CANCELLATION-COVERAGE-INFORMATION-TITLE'
                ),
                noteText: getHippoText('DSS-ADD-SIMPLE-COVERAGE-CANCELLATION-COVERAGE-INFORMATION'),
                theme: 'info'
            };
        case TRAVEL_TYPE_HOUSEHOLD:
            return {
                noteTitle: getHippoText(
                    'DSS-ADD-SIMPLE-COVERAGE-CANCELLATION-COVERAGE-INFORMATION-TRAVEL-TITLE'
                ),
                noteText: getHippoText(
                    'DSS-ADD-SIMPLE-COVERAGE-CANCELLATION-COVERAGE-INFORMATION-TravelTypeHousehold',
                    { renewalDate }
                ),
                theme: 'info'
            };
        case AREA_DESTINATION_WORLDWIDE:
            return {
                noteTitle: getHippoText(
                    'DSS-ADD-SIMPLE-COVERAGE-CANCELLATION-COVERAGE-INFORMATION-TRAVEL-TITLE'
                ),
                noteText: getHippoText(
                    'DSS-ADD-SIMPLE-COVERAGE-CANCELLATION-COVERAGE-INFORMATION-AreaDestinationWorldwide'
                ),
                theme: 'info'
            };
        case AREA_DESTINATION_ONLY_EUROPE:
            return {
                noteTitle: getHippoText(
                    'DSS-ADD-SIMPLE-COVERAGE-CANCELLATION-COVERAGE-INFORMATION-TRAVEL-TITLE'
                ),
                noteText: getHippoText(
                    'DSS-ADD-SIMPLE-COVERAGE-CANCELLATION-COVERAGE-INFORMATION-AreaDestinationOnlyEurope',
                    { renewalDate }
                ),
                theme: 'info'
            };
        default:
            return undefined;
    }
};

export { getAddCoverageHighlightNote };

export default AddCoverageConfig;
